import { render, staticRenderFns } from "./RawMaterialList.vue?vue&type=template&id=23011f3a&scoped=true&"
import script from "./RawMaterialList.vue?vue&type=script&lang=js&"
export * from "./RawMaterialList.vue?vue&type=script&lang=js&"
import style0 from "./RawMaterialList.vue?vue&type=style&index=0&id=23011f3a&lang=scss&scoped=true&"
import style1 from "./RawMaterialList.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23011f3a",
  null
  
)

export default component.exports